import React from "react";
import MetaTitle from "~/components/Shared/MetaTitle";
import { isMobile, isBrowser, isTablet } from 'react-device-detect';
import DesktopContent from "./DesktopContent";
import MobileContent from "./MobileContent";
import Footer from "~/components/Shared/Footer";

const Index = () => {

  return <React.Fragment>
    <div id="content_container">
      <MetaTitle>Insurance</MetaTitle>
      {/* Tablet View */}
      {isTablet && <MobileContent />}
      {/* Browser and not Tablet View */}
      {isBrowser && !isTablet && <DesktopContent />}
      {/* Mobile and not Tablet View */}
      {isMobile && !isTablet && <MobileContent />}
    </div>
    <Footer />
  </React.Fragment>
}

export default Index;
